import {
  TransactionCardTariffPayment,
  TransactionStatus,
} from '@/features/Transactions/transactions.types'
import React from 'react'
import { TransactionRow } from '../Common/TransactionRow'

export function CardTariffPayment({ transaction, onClick, withoutDate }: {
  onClick: () => void;
  transaction: TransactionCardTariffPayment;
  withoutDate: boolean;
}) {
  return (
    <TransactionRow
      amount={transaction.data.cryptoAmount}
      createdAt={transaction.createdAt}
      iconType="PAYMENT"
      isError={transaction.status === TransactionStatus.ERROR_SEND}
      onClick={onClick}
      status={transaction.status}
      title={transaction.data.title}
      type={transaction.data.type}
      withoutDate={withoutDate}
    />
  )
}
